import { styled as styling } from "@mui/material/styles";

// Grid Components //
export const Wrapper = styling("div")((props) => ({
  paddingTop: "40px",

  [props.theme.breakpoints.down("lg")]: {
    marginTop: "0px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    marginTop: "0px",
  },
}));
